export const backendURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://backend-734npnlp6a-uw.a.run.app";
